import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "content", "toggle", "toggleLabel"]

  connect() {
    this.expanded = false
    this.updateToggleVisibility()
  }

  disconnect() {
    this.toggleScrollLock(false, true)
  }

  open(event) {
    if (!this.hasModalTarget) return

    event.preventDefault()
    this.modalTarget.classList.remove("hidden")
    this.modalTarget.classList.add("flex")
    this.toggleScrollLock(true)
  }

  close() {
    if (!this.hasModalTarget) return

    this.modalTarget.classList.add("hidden")
    this.modalTarget.classList.remove("flex")
    this.toggleScrollLock(false)
  }

  toggleExpanded(event) {
    event.preventDefault()
    if (!this.hasContentTarget) return

    this.expanded = !this.expanded
    this.contentTarget.classList.toggle("line-clamp-6", !this.expanded)

    if (this.hasToggleLabelTarget) {
      this.toggleLabelTarget.textContent = this.expanded ? "Show less" : "Show more"
    }

    if (this.hasToggleTarget) {
      this.toggleTarget.setAttribute("aria-expanded", this.expanded ? "true" : "false")
    }
  }

  updateToggleVisibility() {
    if (!this.hasContentTarget || !this.hasToggleTarget) return

    requestAnimationFrame(() => {
      const content = this.contentTarget
      const overflows = content.scrollHeight > content.clientHeight + 1
      this.toggleTarget.classList.toggle("hidden", !overflows)
      this.toggleTarget.classList.toggle("inline-flex", overflows)
    })
  }

  toggleScrollLock(lock, force = false) {
    const body = document.body
    const html = document.documentElement
    let openModals = parseInt(body.dataset.openModals || "0")

    if (lock) {
      openModals++
      body.dataset.openModals = openModals
      
      if (openModals === 1) {
        this.scrollPos = window.pageYOffset
        body.style.position = 'fixed'
        body.style.top = `-${this.scrollPos}px`
        body.style.width = '100%'
        body.classList.add('overflow-hidden')
        html.classList.add('overflow-hidden')
      }
    } else {
      openModals = force ? 0 : Math.max(0, openModals - 1)
      body.dataset.openModals = openModals
      
      if (openModals === 0) {
        const scrollY = body.style.top
        body.style.position = ''
        body.style.top = ''
        body.style.width = ''
        body.classList.remove('overflow-hidden')
        html.classList.remove('overflow-hidden')
        if (!force) {
          window.scrollTo(0, parseInt(scrollY || '0') * -1)
        }
      }
    }
  }

  handleEsc(event) {
    if (event.key === "Escape") this.close()
  }
}
